<template>
    <div class="lobby w-100 h-100 text-center m-0 p-0">
        <div v-if="$store.state.game.images?.lobby_image == null" class="custom-background"></div>
        <div v-else class="custom-background" :style="{ backgroundImage: `url('${$store.state.game.images.lobby_image}')`}"></div>
        <!-- Ambient tint in the player's own jersey color, blended into the
             existing background - a second live 3D render just for this
             would mean two WebGL contexts running at once for one screen,
             so this is a cheap blurred CSS shape instead. -->
        <div v-if="own_jersey_color" class="lobby-color-glow" :style="{ backgroundColor: own_jersey_color }"></div>

        <FullScreen btn_class="btn btn-sm btn-outline-light event-icon-btn position-absolute top-0 start-0 m-3 lobby-logout" />
        <button type="button" class="btn btn-sm btn-outline-light position-absolute top-0 end-0 m-3 lobby-logout" title="Cerrar sesión" @click="logout"><i class="bi bi-box-arrow-left"></i></button>

        <div class="position-fixed w-100 h-100 d-flex justify-content-center align-items-center">
            <div v-if="$store.state.game.user && $store.state.game.styles" class="d-flex flex-column align-items-center text-center">
                <div class="lobby-label">Equipo</div>
                <h1 class="m-0 fw-bolder text-team" :style="$store.state.game.styles.lobby_title">{{ uppercase($store.state.game.user.username) }}</h1>

                <Avatar3DPicker
                    v-if="own_jersey_color"
                    :key="jersey_model_url"
                    class="my-4"
                    :model-url="jersey_model_url"
                    :color-options="[{ label: '', hex: own_jersey_color }]"
                    :model-value="own_jersey_color"
                    :interactive="false"
                    :size="180"
                />
                <div v-else class="lobby-number-ring my-4">
                    <span>{{ $store.state.game.user.avatar }}</span>
                </div>

                <div class="lobby-wait" :style="$store.state.game.styles.lobby_wait"><i class="bi bi-circle-fill me-2"></i>Esperando al resto de equipos</div>

                <TeamMarquee :teams="registered_teams" dark class="mt-4" />
            </div>
        </div>
    </div>
</template>

<script>
import FullScreen from '@/components/FullScreen.vue'
import Avatar3DPicker from '@/components/Avatar3DPicker.vue'
import TeamMarquee from '@/components/TeamMarquee.vue'
import utils from '@/../../shared/utils'
import { get_active_jersey_model_url } from '@/utils/jersey_model'

export default {
    name: "Lobby",
    components: { FullScreen,
        Avatar3DPicker,
        TeamMarquee,
    },
    computed: {
        // This event's own uploaded 3D model, or the app-wide default if it
        // hasn't configured one - see @/utils/jersey_model.js.
        jersey_model_url(){
            return get_active_jersey_model_url();
        },
        // Falls back to the old plain number ring (see template) for anyone
        // who registered before jersey colors existed and has no
        // avatar_style yet.
        own_jersey_color(){
            const user = this.$store.state.game.user;
            return (user && user.avatar_style && user.avatar_style.color) || null;
        },
        // game.clients already carries avatar_style for every connected
        // player (see server.js's list_clients()).
        registered_teams(){
            return (this.$store.state.game.clients || [])
                .filter((cli) => cli.role == utils.USER_ROLES.PLAYER && cli.avatar_style && cli.avatar_style.color)
                .map((cli) => ({ username: cli.username, color: cli.avatar_style.color }));
        }
    },
    mounted(){
        if(window.store.state.network == "connected"){
            window.network.wso.send(
                JSON.stringify(
                    {
                        action: window.RPC.UPDATE_VIEW,
                        params: {
                            view: window.router.currentRoute._value.name,
                            activity: (this.$store.state.game.question) ? this.$store.state.game.question.question.id : null
                        }
                    }
                )
            )
        }
        $('.modal-backdrop').remove();
    },
    methods : {
        uppercase(name)
        {
            return name.toUpperCase();
        },
        logout(){
            utils.reset_client();
        }
    }
}
</script>

<style scoped>
    .lobby{
        position: relative;
        user-select: none;
        overflow: hidden;
        background: radial-gradient(circle at 50% 20%, var(--vc-ink-700), var(--vc-ink-900) 65%);
        color: var(--vc-paper-50);
    }

    .lobby-color-glow{
        position: absolute;
        top: 50%;
        left: 50%;
        width: 140vmax;
        height: 140vmax;
        transform: translate(-50%, -50%);
        border-radius: 50%;
        filter: blur(160px);
        opacity: 0.22;
        pointer-events: none;
    }

    .lobby-label{
        font-family: "Archivo", sans-serif;
        font-weight: 700;
        font-size: 0.9rem;
        text-transform: uppercase;
        letter-spacing: 0.1em;
        color: rgba(255, 255, 255, 0.55);
    }

    .text-team{
      	font-family: "Archivo", sans-serif;
        font-size: 3.2vw;
        line-height: 1.15;
    }

    .lobby-number-ring{
        width: 160px;
        height: 160px;
        border-radius: 999px;
        border: 2px solid var(--vc-accent-500);
        display: flex;
        align-items: center;
        justify-content: center;
        font-family: "Archivo", sans-serif;
        font-weight: 900;
        font-size: 3rem;
        color: var(--vc-accent-500);
    }

    .lobby-wait{
        font-family: "Archivo", sans-serif;
        font-weight: 800;
        font-size: 1.1rem;
        text-transform: uppercase;
        letter-spacing: 0.02em;
    }
    .lobby-wait i{
        font-size: 0.5rem;
        color: var(--vc-accent-500);
        vertical-align: middle;
    }

    .lobby-logout{
        z-index: 30;
    }
</style>
